import { BrowserRouter, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import { ToastContainer } from "react-toastify";
import PrivateRoute from "./PrivateRoute";

/* IMPORT ALL YOUR PAGES HERE */
import HomePageOne from "./pages/HomePageOne";

import ErrorPage from "./pages/ErrorPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";

import SignInPage from "./pages/SignInPage";
import SignUpPage from "./pages/SignUpPage";

import ViewProfilePage from "./pages/ViewProfilePage";
import { ClassPage } from "./pages/ClassPage";
import { TeacherPage } from "./pages/TeacherPage";
import { MangerPage } from "./pages/MangerPage";
import StudentPageList from "./pages/StudentPageList";
import AddStudentPage from "./pages/AddStudentPage";
import SchoolTimingsPage from "./pages/SchoolTimingsPage";
import AttendanceDashboardPage from "./pages/AttendanceDashboardPage";
import ClasswiseAttendancePage from "./pages/ClasswiseAttendancePage";
import AttendanceReportsPage from "./pages/AttendanceReportsPage";
import SingleClassAttendancePage from "./pages/SingleClassAttendancePage";
import MyDevicesPage from "./pages/MyDevicesPage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ToastContainer autoClose={1000} />

      <Routes>
        {/* PUBLIC ROUTES */}
        <Route exact path="/sign-in" element={<SignInPage />} />
        <Route exact path="/sign-up" element={<SignUpPage />} />
        <Route exact path="/forgot-password" element={<ForgotPasswordPage />} />

        {/* PROTECTED ROUTES */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Routes>
                <Route exact path="/" element={<HomePageOne />} />
                <Route
                  exact
                  path="/view-profile"
                  element={<ViewProfilePage />}
                />

                <Route
                  exact
                  path="/classes-management"
                  element={<ClassPage />}
                />
                <Route
                  exact
                  path="/teacher-management"
                  element={<TeacherPage />}
                />

                <Route
                  exact
                  path="/files-management"
                  element={<MangerPage />}
                />
                <Route
                  exact
                  path="/add-student-page"
                  element={<AddStudentPage />}
                />
                <Route
                  exact
                  path="/add-student-page/:id"
                  element={<AddStudentPage />}
                />
                <Route
                  exact
                  path="/edit-student-page/:id"
                  element={<AddStudentPage />}
                />

                <Route
                  exact
                  path="/student-page-list"
                  element={<StudentPageList />}
                />

                <Route
                  exact
                  path="/school-timings"
                  element={<SchoolTimingsPage />}
                />

                <Route exact path="/attendance/dashboard" element={<AttendanceDashboardPage />} />
                <Route exact path="/attendance/classwise" element={<ClasswiseAttendancePage />} />
                <Route exact path="/attendance/reports" element={<AttendanceReportsPage />} />
                <Route exact path="/attendance/class/:id" element={<SingleClassAttendancePage />} />
                <Route exact path="/my-devices" element={<MyDevicesPage />} />

                <Route exact path="*" element={<ErrorPage />} />
              </Routes>
            </PrivateRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
